import { ROUTES } from '~/src/navigation/routes'

import { UserRole } from '~/__generated_types__/globalTypes'

import { RouteGroup, RouteLeaf, RouteNode, SidebarItem } from '~/src/navigation/types'

const isSidebarItemVisible = (
  item: SidebarItem,
  flags: Record<string, boolean>,
  userRole: UserRole
) => {
  if (item.featureFlag && !item.allowedRoles) {
    return Boolean(flags[item.featureFlag])
  }

  if (item.allowedRoles && !item.allowedRoles.includes(userRole)) return false

  return true
}

const isRouteGroup = (route: RouteNode): route is RouteGroup => {
  return 'children' in route
}

const flattenRoutes = (routes: Record<string, RouteNode>): Array<RouteLeaf> => {
  return Object.values(routes).flatMap((route) => {
    if (isRouteGroup(route)) {
      return Object.values(route.children ?? {})
    }

    return [route]
  })
}

const getLogo = (pathname: string): string | undefined => {
  const match = flattenRoutes(ROUTES).find(
    (route) =>
      pathname === route.href ||
      pathname.startsWith(`${route.href}/`) ||
      route.href.startsWith(pathname)
  )

  return match?.logo
}

const getAllHrefs = (items: Array<SidebarItem>): Array<string> => {
  return items.flatMap((item) => {
    if (item.kind === 'link') {
      return [item.href]
    }

    if (item.kind === 'menu') {
      return item.items.map((child) => child.href)
    }

    return []
  })
}

const isPathInSidebar = (pathname: string, items: Array<SidebarItem>): boolean => {
  const hrefs = getAllHrefs(items)

  return hrefs.some((href) => href.split('?')[0] === pathname)
}

export { isSidebarItemVisible, getLogo, isPathInSidebar }
